// Imports: local files.
import {
  GET_ALL_HEAR_ABOUT_START,
  GET_ALL_HEAR_ABOUT_SUCCESS,
  GET_ALL_HEAR_ABOUT_FAILED,
  GET_ALL_HEAR_ABOUT_RESET,
  GET_ONE_HEAR_ABOUT_START,
  GET_ONE_HEAR_ABOUT_SUCCESS,
  GET_ONE_HEAR_ABOUT_FAILED,
  GET_ONE_HEAR_ABOUT_RESET,
  CREATE_HEAR_ABOUT_START,
  CREATE_HEAR_ABOUT_SUCCESS,
  CREATE_HEAR_ABOUT_FAILED,
  CREATE_HEAR_ABOUT_RESET,
  UPDATE_ONE_HEAR_ABOUT_START,
  UPDATE_ONE_HEAR_ABOUT_SUCCESS,
  UPDATE_ONE_HEAR_ABOUT_FAILED,
  UPDATE_ONE_HEAR_ABOUT_RESET,
  DELETE_ONE_HEAR_ABOUT_START,
  DELETE_ONE_HEAR_ABOUT_SUCCESS,
  DELETE_ONE_HEAR_ABOUT_FAILED,
  DELETE_ONE_HEAR_ABOUT_RESET,
} from '../actions/actions';

const initialLoadingState = {
  loading: false,
  success: false,
  data: null,
  error: false,
  errorMessage: null,
};
const initialState = {
  getAll: initialLoadingState,
  getOne: initialLoadingState,
  create: initialLoadingState,
  updateOne: initialLoadingState,
  deleteOne: initialLoadingState,
};

const hearAboutReducer = (state = initialState, action) => {
  switch (action.type) {
    /**
     * =======================================================================
     * Get All Hear About
     * =======================================================================
     */
    case GET_ALL_HEAR_ABOUT_START:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_HEAR_ABOUT_SUCCESS:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_HEAR_ABOUT_FAILED:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_HEAR_ABOUT_RESET:
      return { ...state, getAll: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Get One Hear About
     * =======================================================================
     */
    case GET_ONE_HEAR_ABOUT_START:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_HEAR_ABOUT_SUCCESS:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_HEAR_ABOUT_FAILED:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_HEAR_ABOUT_RESET:
      return { ...state, getOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Create New Hear About
     * =======================================================================
     */
    case CREATE_HEAR_ABOUT_START:
      return { ...state, create: { ...action.payload } };
    case CREATE_HEAR_ABOUT_SUCCESS:
      return { ...state, create: { ...action.payload } };
    case CREATE_HEAR_ABOUT_FAILED:
      return { ...state, create: { ...action.payload } };
    case CREATE_HEAR_ABOUT_RESET:
      return { ...state, create: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Update One Hear About
     * =======================================================================
     */
    case UPDATE_ONE_HEAR_ABOUT_START:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_HEAR_ABOUT_SUCCESS:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_HEAR_ABOUT_FAILED:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_HEAR_ABOUT_RESET:
      return { ...state, updateOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Delete One Hear About
     * =======================================================================
     */
    case DELETE_ONE_HEAR_ABOUT_START:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_HEAR_ABOUT_SUCCESS:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_HEAR_ABOUT_FAILED:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_HEAR_ABOUT_RESET:
      return { ...state, deleteOne: { ...initialLoadingState } };
    default:
      return state;
  }
};

export default hearAboutReducer;
